import { Config } from "./types";

const config: Config = {
  amplify: {
    Auth: {
      Cognito: {
        userPoolId: "ap-southeast-1_DKJ78n7hI",
        userPoolClientId: "1g60rbhhmoi25c1avj1ofh1hgs",
        loginWith: {
          oauth: {
            domain: "ctv-stg.auth.ap-southeast-1.amazoncognito.com",
            redirectSignIn: [
              "https://test-partners.ctv.staging-traveloka.com/",
            ],
            redirectSignOut: [
              "https://test-partners.ctv.staging-traveloka.com/",
            ],
            responseType: "code",
            scopes: ["email", "profile", "openid"],
          },
        },
      },
    },
  },
  apiHost: {
    affiliate: "https://user-api.afc.staging-traveloka.com",
    affiliateStaging: "https://user-api.afc.staging-traveloka.com",
    partner: "https://test-partner-api.ctv.staging-traveloka.com",
    partnerStaging: "https://partner-api.ctv.staging-traveloka.com",
    content: "https://cntpapi.cnt.stg-tvlk.cloud/",
    data: "https://tracking.stg.tvlk-data.com/",
  },
  securePayment: "https://payfrm.pay.staging-traveloka.com",
};

export default config;
